var React = require('react');

function GatsbyInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M40.003.023C17.753.023.023 17.753.023 40c0 22.247 17.73 39.983 39.977 39.983 22.247 0 39.98-17.73 39.98-39.98 0-22.25-17.727-39.98-39.977-39.98zM8.713 40.35l30.944 30.943c-17.037 0-30.944-13.906-30.944-30.943zm38.244 30.247L9.41 33.05C12.533 19.143 25.053 8.713 40 8.713A31.587 31.587 0 0 1 65.38 21.58l-4.517 3.82a25.523 25.523 0 0 0-21.206-11.123 25.183 25.183 0 0 0-23.99 17.033l32.68 32.683c8-2.783 14.253-9.733 15.993-18.08H50.78v-5.91h20.513c0 14.95-10.43 27.467-24.336 30.594z"}));
}

GatsbyInline.defaultProps = {"aria-hidden":"true","focusable":"false","viewBox":"0 0 80 80"};

module.exports = GatsbyInline;

GatsbyInline.default = GatsbyInline;
